import React from 'react';

const Stats = () => {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-grid">
          <div className="stat">
            <h3>10K+</h3>
            <p>Students</p>
          </div>
          <div className="stat">
            <h3>500+</h3>
            <p>Courses</p>
          </div>
          <div className="stat">
            <h3>50+</h3>
            <p>Instructors</p>
          </div>
          <div className="stat">
            <h3>98%</h3>
            <p>Satisfaction</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
